import React, {Component} from 'react';
import {connect} from 'react-redux';
import Settings from './components/settings';
import Stacks from './components/stacks';
import Action from 'components/organisms/dominator-stacking/actions';

class DominatorStacks extends Component {
    onClick(use) {
        this.props.dispatch(Action.do('useDominatorStacking', !use));
    }

    render() {
        const {sportConfig, stacking} = this.props;

        if (!sportConfig.isReady()) {
            return false;
        }

        return (
            <div className={`advanced-filter${stacking.isEnabled() ? ' advanced-open' : ''}`}>
                <div className="advanced-top">
                    <button
                        type="button"
                        onClick={(e) => ::this.onClick(stacking.isEnabled())}
                        className="btn-close-filter"
                    >
                        <i className="fa fa-times-circle"></i>Disable Stacking Options
                    </button>
                    <button
                        type="button"
                        onClick={(e) => ::this.onClick(stacking.isEnabled())}
                        className="advanced-opener"
                    >
                        <i className="fa fa-cog"></i>Dominator Stacking Options
                    </button>
                </div>

                <Settings />
                <Stacks />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {dominatorStacking, sportConfig} = state;
    return {
        stacking: dominatorStacking,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(DominatorStacks);
